import axios from "axios";

export const PRODUCTS_URL = `${process.env.REACT_APP_API_URL}/products`;

// READ
export function getAllProducts(){
    return axios.get(PRODUCTS_URL);
}

export function findProducts(queryParams){
    return axios.get(PRODUCTS_URL, {
        params: {
            pageSize: queryParams.pageSize,
            pageNumber: queryParams.pageNumber,
            categoryId: queryParams.categoryId,
            all: queryParams.all ?? false,
            ...queryParams.filter
        }
    })
}

export function getProductById(id){
    return axios.get(`${PRODUCTS_URL}/${id}`);
}


// FETCH FROM Server
export function fetchProducts(){
    return axios.get(`${PRODUCTS_URL}/FETCH`);
}

export function updateProduct(product){
    return axios.put(`${PRODUCTS_URL}/Update`, product);
}

export function getCategories(){
    return axios.get(`${PRODUCTS_URL}/categories`);
}